import {api} from './api';
import {buildURLSearch} from '../utils/apiUtils';

export const abbreviationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAbbreviations: builder.query<
      {id: number; longName: string; shortName: string}[],
      {shortName?: string; shortNameMatchMode?: number}
    >({
      query: ({shortName, shortNameMatchMode}) =>
        `/abbreviations${buildURLSearch({state: true, shortName, shortNameMatchMode, pageNumber: 1, pageSize: 100})}`,
    }),
  }),
});

export const {useGetAbbreviationsQuery} = abbreviationApi;
